import script from "./EditUserGroupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserGroupForm.vue?vue&type=script&setup=true&lang=js"

import "./EditUserGroupForm.vue?vue&type=style&index=0&id=8586e5fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8586e5fc"]])

export default __exports__